import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { AttachedFilesState } from "@reducers/types/HRM/attachedFiles-state";

import {
  createAttachedFileRequest,
  getAttachedFilesRequest,
  deleteAttachedFileRequest,
} from "@actions/HRM/employee/attachedFiles-actions";
import { getAttachedFilesState } from "@selectors/HRM/employee/attachedFiles-selector";

import { useAppSelector } from "@helpers/redux";

import { UploadFileType } from "@type/HRM/upload-file";
import { AttachedFilesType } from "@type/HRM/attached-files";

interface UseAttachedFiles {
  attachedFiles: AttachedFilesType;
  createAttachedFile: (data: UploadFileType) => void;
  removeAttachedFile: (data: UploadFileType) => void;
  isCreateSuccess: boolean;
  request?: boolean;
  createAttachedFileRequestOngoing: boolean;
  createAttachedFileSuccess: boolean;
  createAttachedFileFailed: boolean;
  getAttachedFilesRequestOngoing: boolean;
  getAttachedFilesSuccess: boolean;
  getAttachedFilesFailed: boolean;
  deleteAttachedFileRequestOngoing: boolean;
  deleteAttachedFileSuccess: boolean;
  deleteAttachedFileFailed: boolean;
}

export const useAttachedFiles = (id: number | null): UseAttachedFiles => {
  const dispatch = useDispatch();
  const {
    success,
    request,
    data,
    createAttachedFileRequest: createAttachedFileRequestOngoing,
    createAttachedFileSuccess,
    createAttachedFileFailed,
    getAttachedFilesRequest: getAttachedFilesRequestOngoing,
    getAttachedFilesSuccess,
    getAttachedFilesFailed,
    deleteAttachedFileRequest: deleteAttachedFileRequestOngoing,
    deleteAttachedFileSuccess,
    deleteAttachedFileFailed,
  } = useAppSelector<AttachedFilesState>(getAttachedFilesState);

  // GET ATTACHED FILES
  useEffect(() => {
    if (id) dispatch(getAttachedFilesRequest(id));
  }, [id, dispatch]);

  //CREATE ATTACHED FILES
  const createAttachedFile = (data: UploadFileType) => {
    dispatch(createAttachedFileRequest({ employeeID: id, ...data }));
  };

  //DELETE ATTACHED FILE
  const removeAttachedFile = (data: UploadFileType) => {
    dispatch(
      deleteAttachedFileRequest({ employeeID: id, fileData: data }),
    );
  };

  const attachedFiles = data as AttachedFilesType;

  return {
    attachedFiles,
    createAttachedFile,
    removeAttachedFile,
    isCreateSuccess: success as boolean,
    request,
    createAttachedFileRequestOngoing,
    createAttachedFileSuccess,
    createAttachedFileFailed,
    getAttachedFilesRequestOngoing,
    getAttachedFilesSuccess,
    getAttachedFilesFailed,
    deleteAttachedFileRequestOngoing,
    deleteAttachedFileSuccess,
    deleteAttachedFileFailed,
  };
};
